import React from "react"
import ProfileSettingsCard from "./ProfileSettingsCard"
import AccountTypeCard from "./AccountTypeCard"
import CustomerSupportCard from "./CustomerSupportCard"
import DeleteAccountCard from "./DeleteAccountCard"

const Profile = () => {
  return (
  <div 
    className="w-full flex flex-col xl:flex-row gap-[30px] xl:gap-[20px] pb-[200px] items-center xl:items-start justify-center"
  >
    <div className="w-full xl:w-1/2 max-w-[554px] flex flex-col items-center xl:items-end gap-[30px] xl:gap-[20px]">
      <AccountTypeCard />
      <ProfileSettingsCard />
    </div>

    <div className="w-full xl:w-1/2 max-w-[554px] flex flex-col items-center xl:items-start gap-[30px] xl:gap-[20px]">
      <CustomerSupportCard />
      <DeleteAccountCard />
    </div>
  </div>
  )
}

export default Profile
